export default __webpack_public_path__ + "images/0x130966628846bfd36ff31a822705796e8cb8c18d.png";